import axios from "axios";
export const BaseUrl = window.RUNTIME_CONFIG.BASE_URL;


// export const BaseUrl = "https://log.poweramr.com/api/";

//export const BaseUrl = "http://api.solaramr.com/api/";


export default axios.create({
    baseURL: BaseUrl
})

// export const LOC_CODE = localStorage.getItem('LCODE')
// export const LOGIN_ID = localStorage.getItem('LoginID')
export const PASS_KEY = "xyz"
export const WEB_KEY = "WEBXYZ321"
export const APP_KEY = "WEBXYZ321"
export const DATA_TYPE = "1"
export const DT1 = "01-DEC-2023"
export const DT2 = "18-DEC-2023"

// for HYBRD







